const languages: Record<string, Record<string, string>> = {
  en: { nativeName: 'English' },
  fr: { nativeName: 'French' },
};

export default languages;